export default "__VITE_ASSET__CySQfAhQ__"